<template>
  <form @submit.prevent="submitForm()" novalidate>
    <div>
      <mu-row gutter>
        <mu-col width="80" desktop="50" tablet="70">
          <mu-row gutter>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-time-picker
                :label="$t('message.labelTime')"
                mode="portrait"
                fullWidth
                v-model="timeModel.time"
                :okLabel="$t('message.okText')"
                :cancelLabel="$t('message.cancelText')"
              ></mu-time-picker>
            </mu-col>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-date-picker
                :label="$t('message.labelDate')"
                :okLabel="$t('message.okText')"
                :cancelLabel="$t('message.cancelText')"
                :dateTimeFormat="dateFormat"
                format="DD-MM-YYYY"
                v-model="timeModel.date"
                :maxDate="maxDate"
                fullWidth
              ></mu-date-picker>
            </mu-col>
          </mu-row>
          <mu-row>
            <mu-col desktop="100" tablet="100" width="100">
              <mu-row>
                <mu-col width="100" tablet="100" desktop="100" v-if="preference === 'kg'">
                  <mu-text-field
                    v-validate
                    data-vv-validate-on="none"
                    :data-vv-rules="'required|min_value:0|max_value:635'"
                    data-vv-name="kg"
                    data-vv-value-path="inputValue"
                    :errorText="errors.first('kg')"
                    type="number"
                    label="KG"
                    :hintText="$t('message.placeholderText')"
                    v-model.number="reading.kg"
                    :fullWidth="true"
                  />
                </mu-col>
                <mu-col width="100" tablet="100" desktop="100" v-if="preference === 'lbs'">
                  <mu-text-field
                    v-validate
                    data-vv-validate-on="none"
                    :data-vv-rules="'required|min_value:0|max_value:750'"
                    data-vv-name="lbs"
                    data-vv-value-path="inputValue"
                    :errorText="errors.first('lbs')"
                    type="number"
                    label="LBS"
                    :hintText="$t('message.placeholderText')"
                    v-model.number="reading.lbs"
                    :fullWidth="true"
                  />
                </mu-col>
                <mu-col width="100" tablet="50" desktop="100" v-if="preference === 'st-lbs'">
                  <mu-text-field
                    v-validate
                    data-vv-validate-on="none"
                    :data-vv-rules="'required|min_value:0|max_value:100'"
                    data-vv-name="stones"
                    data-vv-value-path="inputValue"
                    :errorText="errors.first('stones')"
                    type="number"
                    label="ST"
                    :hintText="$t('message.placeholderText')"
                    v-model.number="reading.stones"
                    :fullWidth="true"
                  />
                </mu-col>
                <mu-col width="100" tablet="100" desktop="100" v-if="preference === 'st-lbs'">
                  <mu-text-field
                    v-validate
                    :data-vv-rules="'required|min_value:0|max_value:13'"
                    data-vv-name="pounds"
                    data-vv-value-path="inputValue"
                    :errorText="errors.first('pounds')"
                    type="number"
                    label="LBS"
                    :hintText="$t('message.placeholderText')"
                    v-model.number="reading.pounds"
                    :fullWidth="true"
                  />
                </mu-col>
              </mu-row>
            </mu-col>
          </mu-row>
        </mu-col>
      </mu-row>
    </div>

    <button type="submit" style="display: none"></button>
    <mu-flat-button
      style="margin-right: 8px;"
      :label="$t('message.discardText')"
      @click.native="closeEditMode(reading)"
    ></mu-flat-button>
    <mu-raised-button
      @click.native="submitForm()"
      :disabled="isUpdating"
      :label="isUpdating ? $t('message.updatingText') : $t('message.updateText')"
      type="button"
      secondary
    ></mu-raised-button>
  </form>
</template>
<script>



  import WeightApi from '../../../../api/Tracking/Weight'

  import ScrollerMixin from '../../../../mixins/ScrollerMixin'
  import TrackingEditMixin from '../../../../mixins/TrackingEditMixin'


  export default {
    mixins: [ScrollerMixin, TrackingEditMixin],
    name: 'weight-edit',
    props: {
      preference: {
        type: String,
        default: 'kg'
      },
      item: {
        type: Object,
        default: {}
      }
    },
    data: function() {
      return {
        isUpdating: false,
        reading: {}
      }
    },
    methods: {
      submitForm: function() {
        let self = this;
        self.$validator.validateAll()
          .then(function (valid) {
            if (valid) {
              let model = {};
              self.isUpdating = true;
              model.date = self.reading.date;
              model.progress_id = self.reading.progress_id;
              model.tracking_id = self.reading.tracking_id;
              if (self.preference === 'st-lbs') {
                model.stones = self.reading.stones;
                model.pounds = self.reading.pounds;
              }
              if (self.preference === 'lbs') {
                model.lbs = self.reading.lbs
              }
              if (self.preference === 'kg') {
                model.kg = self.reading.kg
              }
              WeightApi.updateWeightTracking(model)
                .then(function (response) {
                  let offset = new Date();
                  self.reading.date_created = moment(self.reading.date).add(offset.getTimezoneOffset().toString().replace('-', ''), 'minutes')
                  self.$emit('updateReading', self.reading);
                  self.$emit('closeEditPanel');
                  self.isUpdating = false;
                })
                .catch(function () {
                  self.isUpdating = false;
                })
            }
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// WeightEdit.vue?1b731a36